import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs } from 'types/src/pages';

@Component
export default class PagesBlogMixin extends Vue {
  // Data
  readonly name = 'Блог';
  readonly link = 'blog';

  // computed
  get breadcrumbsLead(): Breadcrumbs {
    return [{ text: 'Главная', to: '/' }];
  }

  get breadcrumbs(): Breadcrumbs {
    const { $options, breadcrumbsLead, name, link } = this;
    const crumb = {
      text: name,
      to: { name: link },
    };
    return [...($options.breadcrumbsLead || breadcrumbsLead || []), crumb];
  }
}



// WEBPACK FOOTER //
// ./src/pages/blog/mixins/mixin.ts